/**
 * this is the controller to handle actions and settings for the sidebar
 **/
export default class SidebarController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		this.AppConfig = $injector.get('app.config');
	}

	/**
	 * initialize the component
	 **/
	$onInit() {

	}
}
